import { QueueDashboard } from "../../features/queue-monitoring";

export function AdminQueuesPage() {
  return <QueueDashboard />;
}
